
import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react'
import AsyncAutocomplete from '../../comman/AsyncAutoComplete';
import { apiRequest } from '../../../utils/config/apiRequest';
import { apiUrl } from '../../../utils/endPoints/apiUrl';

export default function AssignDriver({ 
    orderId, 
    shopId, 
    OnSelect = () => { } }) {

    const [selectRider, setSelectedRider] = useState();

    const getStaffs = async (searchQ) => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.staff.shopStaff,
            query: {
                searchQ,
                shopId: shopId || ''
            },
        });

        if (status) return data?.rows || []
        else return []
    }

    const handleAssignDriver = async (rider) => {
        setSelectedRider(rider)
        const { status } = await apiRequest({
            method: 'POST',
            endUrl: apiUrl.orders.assignRider(orderId),
            showMsg: true,
            body: {
                riderId: rider?.staffId?._id
            }
        });

        if (status) {
            OnSelect();
        }
    }

    return (
        <React.Fragment>
            <AsyncAutocomplete
                prefetch
                prefetchDependency={[shopId]}
                label="Staff"
                placeholder="Assign staff"
                value={selectRider}
                onChange={(val) => handleAssignDriver(val)}
                fetchOptions={getStaffs}
                getOptionLabel={(option) => option?.staffId?.userName || ""}
                isOptionEqualToValue={(o, v) => o?.staffId?._id === v?.staffId?._id}
                renderOption={(props, option) => (
                    <li {...props} key={option?.staffId?._id}>
                        <Stack>
                            <Typography variant='subtitle2'> {option?.staffId?.userName} </Typography>
                            <Typography variant='caption'>{option?.staffId?.email}</Typography>
                        </Stack>
                    </li>
                )}
            />
        </React.Fragment>
    )
}
